module.exports = __webpack_public_path__ + "static/media/red.fbe6fba9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/space-gray-aluminum-case/red.jpeg
// module id = 2036
// module chunks = 0